module.exports = __webpack_public_path__ + "static/media/sign_up_right_side_2.5b20110b.svg";